import { GatsbyImage } from 'gatsby-plugin-image'
import React from 'react'

const HomeReviewBox = ({appsumoImage, starGroupImage, userImage, eyeImage}) => {
    return (
        <>
            <div className="w-11/12 lg:w-10/12 py-5 lg:py-0 lg:h-24 mx-auto absolute -bottom-36 xs:-bottom-24 md:-bottom-32 lg:-bottom-7 left-0 right-0 flex flex-col space-y-6 lg:space-y-0 lg:flex-row lg:items-center lg:justify-between bg-white rounded-md" style={{border: '0.75px solid #006BFF'}}>

                <div className="px-3 lg:px-5">

                    <div className="flex flex-row items-center space-x-4">
                        <GatsbyImage image={appsumoImage} alt="Like" />
                        <div className="flex flex-col items-start">
                            <GatsbyImage image={starGroupImage} alt="Stars" />
                            <span className="text-secondary text-sm md:text-base lg:text-lg font-medium font-poppins">120+ 5-Star Reviews on AppSumo</span>
                        </div>
                    </div>

                </div>

                <div className={`w-4/5 mx-auto h-0 lg:w-0 lg:h-12 review-box-horizontal-divider review-box-vertical-divider`}>&nbsp;</div>

                <div className="px-3 lg:px-5">

                    <div className="flex flex-row items-center space-x-4">
                        <GatsbyImage image={userImage} alt="User" />
                        <span className="text-secondary text-sm md:text-base lg:text-lg font-medium font-poppins">10,000+ Active users</span>
                    </div>
                    
                </div>

                <div className={`w-4/5 mx-auto h-0 lg:w-0 lg:h-12 review-box-horizontal-divider review-box-vertical-divider`}>&nbsp;</div>

                <div className="px-3 lg:px-5">

                    <div className="flex flex-row items-center space-x-5">
                        <GatsbyImage image={eyeImage} alt="Vision" className="w-10 h-10" />
                        <span className="text-secondary text-sm md:text-base lg:text-lg font-medium font-poppins">3 Million+ Popup Views </span>
                    </div>
                    
                </div>

                
            </div>
        </>
    )
}

export default HomeReviewBox
